(function () {
    'use strict';

    angular
        .module('bcmModule')
        .directive('biaBuOwner', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);

        directiveScope.editAction = '&';
        directiveScope.onSelect = '&';
        directiveScope.removeAction = '&';
        directiveScope.isCompleted = '=';
        directiveScope.maxNbBiaBuOwner = '=';
        directiveScope.isSelectable = '=';
        directiveScope.onSave = '&';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope', '$controller',
                function ($scope, $controller) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/BCM/BIABUOwner/biaBuOwner.[Template].tpl.html';

                    // Permissions default values
                    $scope.boxFeatureRole = $scope.boxFeatureRole || 'BCMManagement';
                    $scope.boxPermissionKey = $scope.boxPermissionKey || 'BIAProfile';

                    $controller('BoxTmplController', { $scope: $scope });

                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);

                if (!_.isUndefined(attrs.editAction) || !_.isUndefined(attrs.removeAction)) scope.withActions = true;
                if (!_.isUndefined(attrs.onSelect)) scope.showOnSelectAction = true;
            }
        }
    }
})();
